import(/* webpackMode: "eager" */ "/app/components/AccordionPanels.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/BlurImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/CheckAvailabilityType1.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/CheckAvailabilityType2.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/ContactFormSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/DarkSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FaqAccordion.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/GallerySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/HotelOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/LocationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/MapWithDirections.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/RoomsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/TimelineSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
